import {usePapaParse} from "react-papaparse";
import {useEffect, useState} from "react";
import {Grid, Box} from "@mui/material";

//components
import LineSvg from "../../LineSvg";
import CustomLink from "../../Common/CustomLink";
import ModalTrigger from "../../Common/ModalTrigger";
import Samples from "../Samples";

//maps
import ChapterOneMap from "../../Maps/ChapterOneMap";
import mapJSON from "../../../Data/JSON/ChapterOneMap.json";
import mapCSV from "../../../Data/EUMACP/Overview/EU-MACP-Overview-No-of-samples-per-country-and-food-commodity.csv";

const FirstRow = () => {
  const [countryData, setCountryData] = useState(undefined);
  const handleCountryClick = (evt) => {
    setCountryData(evt);
    if (evt === undefined) {
      handleReadString();
    }
  };
  const {readString} = usePapaParse();
  const handleReadString = () => {
    readString(mapCSV, {
      complete: (results, file) => {
        const initialData = {country: "All", data: []};
        const foodCommodities = results.data.map((d) => d["Food commodity"]);
        const unique = [...new Set(foodCommodities)];

        unique.forEach((fc) => {
          if (fc) {
            initialData.data.push({
              country: "All",
              "Food commodity": fc,
              Samples: 0,
            });
          }
        });
        results.data.forEach((d) => {
          const found = initialData.data.find(
            (da) => da["Food commodity"] === d["Food commodity"]
          );
          if (found) {
            found["Samples"] += d["Samples"];
          }
        });
        setCountryData(initialData);
      },
      download: true,
      header: true,
      dynamicTyping: true,
      error: (error, file) => {
        console.log("Error while parsing:", error, file);
      },
    });
  };
  useEffect(() => {
    handleReadString();
  }, []);

  return (
    <Grid
      item
      container
      direction={ {xs: "column", sm: "column", md: "row"} }
      sx={ {marginTop: {xs: "50px", sm: "50px", md: "90px"}} }
      className="one-map-wrapper"
    >
      <Grid item xs display="flex" flexDirection="column" p={ 3 }>
        <Box
          display="flex"
          flexDirection="column"
          sx={ {
            paddingBottom: {md: "4rem"},
          } }
        >
          <div className="lineSvg">
            <LineSvg/>
          </div>
          <span>EU MACP RESULTS</span>
          <h3>Results by reporting country</h3>
          <p className="paragraph">
            The EU-Coordinated Multiannual Control Programme (<ModalTrigger
            style={ {
              color: "#22294D",
              cursor: "pointer",
              borderBottom: "1px dotted",
            } }
            text="EU MACP"
          />) analyses randomly collected samples of 12 food products. The same products are sampled every three years in order to track trends.
          </p>

          <p className="paragraph">
            In accordance with{ " " }
            <CustomLink
              href="https://eur-lex.europa.eu/legal-content/en/TXT/?uri=CELEX%3A32022R0741"
              text="Regulation (EU) 2022/741"
            />
            ,{ " " }
            <ModalTrigger
              style={ {
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              } }
              text="EU Member States"
            />
            , Iceland and Norway were requested to take a total of 683 samples per commodity.
          </p>
          <p className="paragraph">
            This minimum number was reached for all commodities except for rye (654 samples, of which 235 samples were of wholemeal flour as permitted under the Regulation).
          </p>
          {/* <p className='paragraph'>
           For all 12 commodities the minimum number of 683 samples was
           reached, which is required to estimate a minimum 1%{' '}
           <ModalTrigger
           style={{ color: '#22294D', cursor: 'pointer' }}
           text='MRL exceedances'
           />{' '}
           with a margin of error of 0.75% (for virgin olive oil, 682 samples
           were reported).
           </p> */ }
        </Box>
        <Box
          sx={ {display: {xs: "none", sm: "block", md: "block"}} }
          className="dataBox1"
        >
          <Samples data={ countryData } chunkSize={ 4 }/>
        </Box>
      </Grid>
      <Grid item xs className="one-two" p={ 3 }>
        <ChapterOneMap
          onCountryClick={ handleCountryClick }
          json={ mapJSON }
          csv={ mapCSV }
          data={ countryData }
        />

        <Box
          className="mapTitle"
          sx={ {display: {xs: "none", md: "contents"}, marginTop: "2rem"} }
        >
          <p>No baby food samples are included in this representation.</p>
        </Box>
      </Grid>
      <Grid
        item
        p={ 3 }
        xs
        sx={ {
          display: {xs: "block", sm: "none", md: "none"},
        } }
        className="one-three"
      >
        <Samples p={ 5 } data={ countryData } chunkSize={ 7 }/>
      </Grid>
    </Grid>
  );
};

export default FirstRow;
